import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import '../../simulation-summary/components/summary-bar-chart/index.scss';
import '../../simulation-summary/simulation-summary.scss';
import BarChart from '../../simulation-summary/components/summary-bar-chart/bar-chart';
import { abbreviateNumber } from '../../simulation-summary/utils/utils';
import { chartTypeMap } from '../../simulation-summary/utils/constants';

export default function ComparisonBarChart({
  chartData,
  barWidthValue,
  metricsObject,
  columnCount
}: {
  // chartData: BarChartDetails;
  chartData: any;
  barWidthValue: number;
  metricsObject: object;
  columnCount: number;
}) {
  const axisKeys = [
    {
      key: 'change_abs',
      alias: 'Abs',
      color: chartData.change_abs < 0 ? '#B80302' : '#0FB052'
    }
  ];

  return (
    <div
      className='chart-div'
      style={{ minHeight: 'auto', width: `${140 / columnCount}%` }}
      key={`chart_${chartData.metric}`}
    >
      {/* <div style={{ marginTop: '5px' }} className='chart-title'>{chartData.alias}</div> */}
      <div className='legend-div'>
        <BarChart
          barWidthValue={barWidthValue}
          barData={chartData}
          height={30}
          axisKeys={axisKeys}
          type={chartTypeMap.comparisonBarChart}
          minMaxMap={metricsObject}
        />
      </div>
      <div
        className='chart-title flex-div'
        style={{ margin: '5px 5px 5px 5px' }}
      >
        <div style={{ fontSize: '12px' }}>
          {abbreviateNumber(chartData.currency_label, chartData.change_abs)}
        </div>
        <div
          className={`flex-div ${chartData.change_perc > 0 ? 'positive-div' : 'negative-div'
            }`}
          style={{ fontSize: '12px' }}
        >
          {chartData.change_perc > 0 ? (
            <ArrowDropUpIcon />
          ) : (
            <ArrowDropDownIcon />
          )}
          {chartData.change_perc}%
        </div>
      </div>
    </div>
  );
}
